var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"check",class:{
    'check--disabled': _vm.disabled,
    'check--error': _vm.error,
    'check--checked': _vm.checked,
    'check--indeterminate': _vm.indeterminate,
  }},[_c('span',{staticClass:"check__state"},[(_vm.checked)?[_c('check-icon')]:_vm._e()],2),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"type":"checkbox","disabled":_vm.disabled,"indeterminate":_vm.indeterminate},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('change', $event.target.checked)}}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }